"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * HD Wallet coin type
 */

exports.COIN_TYPE = 2;
/**
 * The account address starts with "10"
 */

exports.PREFIX_ADDRESS_ACCOUNT = 0x10;
/**
 * There is a timeout gap in Muta chain, by default,
 * Muta only process request a period of time according to the epoch height
 */

exports.DEFAULT_TIMEOUT_GAP = 20;
/**
 * The RLP Serialized transfer transaction prefix
 */

exports.PREFIX_TRANSACTION_TRANSFER = 0x00;